// frontend/src/hooks/useAdminFeedback.ts
import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface SignalCount {
  signal_type: string;
  count: number;
}

export interface WeeklyAccumulationPoint {
  week_start: string; // ISO 8601, UTC
  count: number;
}

export interface ConceptFeedbackRow {
  concept_id: string;
  name: string;
  owner_email: string;
  total: number;
  high_confidence: number;
  last_at: string;
}

export interface FeedbackMetricsResponse {
  period_days: number;
  signal_distribution: SignalCount[];
  high_confidence_count: number;
  high_confidence_target: number;
  weekly_accumulation: WeeklyAccumulationPoint[];
  by_concept: ConceptFeedbackRow[];
}

export function useAdminFeedbackMetrics(days: number) {
  return useQuery<FeedbackMetricsResponse>({
    queryKey: ["admin", "feedback-metrics", days],
    queryFn: () =>
      apiClient
        .get("api/admin/feedback-metrics", { searchParams: { days } })
        .json<FeedbackMetricsResponse>(),
    staleTime: 60_000,
    retry: false,
  });
}
